import React from 'react';
import { StyleSheet, View } from 'react-native';
import FastImage from 'utils/packages/rnFastImage';
import { AppView, Button, ButtonGroup, Spacer, rem } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import { tierThemes } from 'features/premium/benefits';
import { useHeaderHeight } from 'hooks';
import Pricing from './Pricing';
const strings = {
    noThanks: 'No, thanks',
};
const PromotionWithPresentAndTagLayout = ({ formattedPrices, subscription, isFetching, positiveButtonText, onPressDecline, onPressPurchase, }) => {
    const headerHeight = useHeaderHeight();
    const percentOffImage = () => {
        if (formattedPrices.percentOff === 50) {
            return (<View>
          <FastImage source={require('../img/intro_50.png')} resizeMode="contain" style={styles.giftImage_Percent}/>
        </View>);
        }
        if (formattedPrices.percentOff === 70) {
            return (<View>
          <FastImage source={require('../img/intro_70.png')} resizeMode="contain" style={styles.giftImage_Percent}/>
        </View>);
        }
        return null;
    };
    return (<AppView>
      <StatusBar barStyle="dark-content" animated/>

      <View style={[
            styles.contentContainer,
            {
                paddingTop: headerHeight,
            },
        ]}>
        {formattedPrices.percentOff === 50 ||
            formattedPrices.percentOff === 70 ? (percentOffImage()) : (<>
            <View>
              <FastImage source={require('../img/gift.png')} resizeMode="contain" style={styles.giftImage}/>
              <View style={styles.giftLabel}>
                <FastImage source={require('../img/gift_label.png')} resizeMode="contain" style={styles.giftLabelImage}/>
                <FastImage source={require('../img/percentOff.png')} resizeMode="contain" style={styles.percentOffImage}/>
                <View style={styles.giftLabelText}>
                  <Text Numbers-48 White>
                    {formattedPrices.percentOff}
                  </Text>
                </View>
              </View>
            </View>
            <Spacer h={30}/>
          </>)}
      </View>

      <Pricing title={`How about ${formattedPrices.percentOff}% off your next ${tierThemes[subscription.tier].name} renewal?`} formattedPrices={formattedPrices} period={subscription.period} tier={subscription.tier}/>
      <ButtonGroup type="floating">
        <Button brandReversed title={strings.noThanks} onPress={onPressDecline} testID="cancelButton"/>
        <Button title={positiveButtonText} preventDoubleTap brand onPress={onPressPurchase} isFetching={isFetching} testID="purchaseButton"/>
      </ButtonGroup>
    </AppView>);
};
const styles = StyleSheet.create({
    contentContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    giftImage: {
        height: rem(205),
        width: rem(205),
    },
    giftImage_Percent: {
        height: rem(250),
        width: rem(350),
    },
    giftLabel: {
        position: 'absolute',
        bottom: rem(24),
        left: rem(-45),
        height: rem(110),
        width: rem(110),
    },
    percentOffImage: {
        position: 'absolute',
        width: rem(48),
        height: rem(48),
        left: rem(54),
        bottom: rem(48),
    },
    giftLabelText: {
        position: 'absolute',
        bottom: rem(10),
        left: rem(14),
        transform: [{ rotate: '-38.47deg' }],
    },
    giftLabelImage: {
        position: 'absolute',
        height: rem(110),
        width: rem(110),
    },
});
export default PromotionWithPresentAndTagLayout;
